import { useEffect, useRef } from 'react';
import { OnboardDeviceOnlineStatusWsPayload } from '../interfaces';
import { parseOnboardDeviceOnlineStatusWsPayload } from '../utils/onboardDeviceOnlineStatus';
import { subscribeToWebSocket } from '../api/websocket/connection';

interface UseOnboardDevicesStatusWebSocketProps {
    enabled: boolean;
    onStatusUpdate: (payload: OnboardDeviceOnlineStatusWsPayload) => void;
    onConnected?: () => void;
}

/** Device online/offline updates, off the shared websocket. */
export const useOnboardDevicesStatusWebSocket = ({
    enabled,
    onStatusUpdate,
    onConnected,
}: UseOnboardDevicesStatusWebSocketProps) => {
    const onStatusUpdateRef = useRef(onStatusUpdate);
    const onConnectedRef = useRef(onConnected);

    useEffect(() => {
        onStatusUpdateRef.current = onStatusUpdate;
    }, [onStatusUpdate]);

    useEffect(() => {
        onConnectedRef.current = onConnected;
    }, [onConnected]);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        return subscribeToWebSocket({
            onMessage: (data) => {
                const payload = parseOnboardDeviceOnlineStatusWsPayload(data);

                if (payload) {
                    onStatusUpdateRef.current(payload);
                }
            },
            onConnected: () => onConnectedRef.current?.(),
        });
    }, [enabled]);
};
